"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _ = require("./");
var _default = exports.default = function _default(_ref) {
  let {
    preloadedState = undefined,
    middleware = []
  } = _ref;
  return (0, _toolkit.configureStore)({
    reducer: _.ReducerManager.reduce,
    preloadedState,
    middleware: [...(0, _toolkit.getDefaultMiddleware)(), ...middleware]
  });
};